import * as c from "./constant";

export default (state = {}, action) => {
  switch (action.type) {
    case c.load:
      return action.payload;
    default:
      return state;
  }
};
